module.exports = __webpack_public_path__ + "static/media/image.48374657.svg";